/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  SetMcpServerUpstreamAuthRequirementRequestBody,
  SetMcpServerUpstreamAuthRequirementRequestBody$Outbound,
  SetMcpServerUpstreamAuthRequirementRequestBody$outboundSchema,
} from "../components/setmcpserverupstreamauthrequirementrequestbody.js";

export type SetMcpServerUpstreamAuthRequirementSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type SetMcpServerUpstreamAuthRequirementRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  setMcpServerUpstreamAuthRequirementRequestBody:
    SetMcpServerUpstreamAuthRequirementRequestBody;
};

/** @internal */
export type SetMcpServerUpstreamAuthRequirementSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const SetMcpServerUpstreamAuthRequirementSecurity$outboundSchema:
  z.ZodMiniType<
    SetMcpServerUpstreamAuthRequirementSecurity$Outbound,
    SetMcpServerUpstreamAuthRequirementSecurity
  > = z.pipe(
    z.object({
      sessionHeaderGramSession: z.optional(z.string()),
      apikeyHeaderGramKey: z.optional(z.string()),
    }),
    z.transform((v) => {
      return remap$(v, {
        sessionHeaderGramSession: "session_header_Gram-Session",
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
      });
    }),
  );

export function setMcpServerUpstreamAuthRequirementSecurityToJSON(
  setMcpServerUpstreamAuthRequirementSecurity:
    SetMcpServerUpstreamAuthRequirementSecurity,
): string {
  return JSON.stringify(
    SetMcpServerUpstreamAuthRequirementSecurity$outboundSchema.parse(
      setMcpServerUpstreamAuthRequirementSecurity,
    ),
  );
}

/** @internal */
export type SetMcpServerUpstreamAuthRequirementRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  SetMcpServerUpstreamAuthRequirementRequestBody:
    SetMcpServerUpstreamAuthRequirementRequestBody$Outbound;
};

/** @internal */
export const SetMcpServerUpstreamAuthRequirementRequest$outboundSchema:
  z.ZodMiniType<
    SetMcpServerUpstreamAuthRequirementRequest$Outbound,
    SetMcpServerUpstreamAuthRequirementRequest
  > = z.pipe(
    z.object({
      gramSession: z.optional(z.string()),
      gramKey: z.optional(z.string()),
      setMcpServerUpstreamAuthRequirementRequestBody:
        SetMcpServerUpstreamAuthRequirementRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramSession: "Gram-Session",
        gramKey: "Gram-Key",
        setMcpServerUpstreamAuthRequirementRequestBody:
          "SetMcpServerUpstreamAuthRequirementRequestBody",
      });
    }),
  );

export function setMcpServerUpstreamAuthRequirementRequestToJSON(
  setMcpServerUpstreamAuthRequirementRequest:
    SetMcpServerUpstreamAuthRequirementRequest,
): string {
  return JSON.stringify(
    SetMcpServerUpstreamAuthRequirementRequest$outboundSchema.parse(
      setMcpServerUpstreamAuthRequirementRequest,
    ),
  );
}
